import styled from 'styled-components';

export const PricingTable = styled.div`
  width: 360px;
  margin-bottom: 32px;
  margin-top: 16px;
`;
export const PricingTableRow = styled.div`
  display: flex;
  flex-direction: row;
  margin-left: 12px;
`;
export const PricingTableHeader = styled.div`
  font-family: Source Sans Pro;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 18px;
  letter-spacing: 0em;
  text-align: left;
  width: 50%;
  margin-top: 4px;
`;
export const PricingTableBody = styled.div`
  font-family: Source Sans Pro;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  letter-spacing: 0em;
  text-align: left;
  width: 50%;
  margin-top: 12px;
`;
export const PricingTableFeatureRow = styled.div`
  font-size: 14px;
  &:not(:first-child) {
    margin-top: 8px;
  }
`;

export const PricingTableFooter = styled.div`
  display: flex;
  font-family: Source Sans Pro;
  font-size: 14px;
  font-style: italic;
  margin-left: 12px;
  margin-top: 24px;
  color: #515457;
`;
